import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ORingCordComponent } from './o-ring-cord.component';

const routes: Routes = [
  {
    path: '',
    component: ORingCordComponent,
    data: {
      meta: {
        title: 'O-Ring Cord Kits | Marco Sealing Solutions',
        description: 'Explore o-ring cord information as well as contents for the various o-ring splicing kits available at Marco Rubber. Order your o-ring splicing kits online.'
      }
    }
  }
];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class ORingCordRoutingModule { }
